/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

import React, { useContext } from 'react'
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai'
import { Button, Label } from 'reactstrap'
import { AppContext } from '../context/AppContextProvider'

const TicketCounter = () => {
  const minCount = parseInt(process.env.REACT_APP_BUY_TICKET_MIN_AMOUNT, 10) || 1
  const maxCount = parseInt(process.env.REACT_APP_BUY_TICKET_MAX_AMOUNT, 10) || 100
  const { ticketCount, setTicketCount } = useContext(AppContext)

  const increaseCount = () => {
    if (maxCount > ticketCount) {
      setTicketCount(ticketCount + 1)
    }
  }

  const decreaseCount = () => {
    if (minCount < ticketCount) {
      setTicketCount(ticketCount - 1)
    }
  }

  return (
        <div className="py-2">
            <Button outline size="sm" onClick={() => decreaseCount()}>
                <AiOutlineMinus />
            </Button>
            <Label style={{ width: 30, fontSize: 15, fontWeight: 700 }}>{ticketCount}</Label>
            <Button outline size="sm" onClick={() => increaseCount()}>
                <AiOutlinePlus />
            </Button>
        </div>
  )
}

export default TicketCounter
